import Menubar from "../Menubar";
import {
    Trans,
    useTranslation,
    language,
    useI18next,
} from "gatsby-plugin-react-i18next";
import { HubspotBrochureDownload } from ".";
import GCWcarousel from "../GCWcarousel";

function GCWAboutUs() {
    const { t, i18n, changeLanguage } = useI18next();

    return (
        <>
            <Menubar
                whatsInIt={
                    "https://www.vantagefit.io/global-corporate-virtual-walkathon#whatsinit"
                }
                howToJoin={
                    "https://www.vantagefit.io/global-corporate-virtual-walkathon#howtojoin"
                }
                joinNow={
                    "https://www.vantagefit.io/global-corporate-virtual-walkathon#gcwHubspotForm"
                }
            />
            <section className="bannerAreaN greyBackgroundN BannerDeatils">
                <div className="detailsPageSection cg-bg-res">
                    <img
                        src="https://res.cloudinary.com/vantagecircle/image/upload/v1709807887/VantageFit/2023/background-new.webp"
                        alt="corporate wellness"
                        className="img-responsive"
                    />
                </div>
                <div className="row cg-logo">
                    <div className="col-12 col-lg-6 ">
                        <div className="container w-100 h-100 d-flex justify-content-center align-items-center">
                            <h1 className="text-light section-heading text-center">
                                About GCW
                            </h1>
                        </div>
                    </div>
                    <div className="col-12 col-lg-6 mt-4 mt-lg-0">
                        <div className="container row justify-content-end">
                            <div>
                                <img
                                    className="col-10 col-lg-10"
                                    src="https://res.cloudinary.com/vantagecircle/image/upload/v1728368929/VantageFit/2024/walkathon_logo_2024-02_1.png"
                                    alt="GCW"
                                />
                                <div className="col-10 text-right gcwdate1 text-white">
                                    5<sup>th</sup> Nov - 3<sup>rd</sup> Dec
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="position-relative bg-white">
                <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block py-5">
                    <div className="col-12 col-lg-6 d-flex justify-content-center order-1 order-lg-2 py-5 py-lg-0">
                        <img
                            style={{ maxWidth: "400px" }}
                            src="https://res.cloudinary.com/vantagecircle/image/upload/v1728466895/VantageFit/2024/gcw/covid.png"
                            alt="covid"
                        />
                    </div>

                    <div className="col-12 col-lg-6 order-2 order-lg-1">
                        <p className="section-para font-weight-normal m-0">
                            The first Vantage Fit Global Corporate Virtual
                            Walkathon started in October 2021, allowing
                            organizations to unite and promote wellness after
                            the COVID-19 pandemic. The event was received with
                            widespread positivity and witnessed participant
                            companies from more than 24 countries.
                        </p>
                    </div>
                </div>
            </section>

            <section className="position-relative bg-white ">
                <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block py-5">
                    <div className="col-12 col-lg-6 d-flex justify-content-center  py-5 py-lg-0">
                        <img
                            style={{ maxWidth: "400px" }}
                            src="https://res.cloudinary.com/vantagecircle/image/upload/v1728466895/VantageFit/2024/gcw/logos.png"
                            alt="logos"
                        />
                    </div>
                    <div className="col-12 col-lg-6">
                        <p className="section-para font-weight-normal">
                            The virtual walkathon enabled organizations from
                            different backgrounds to showcase their concern for
                            employee well-being and compete in friendly
                            competition against each other.
                        </p>
                        <p className="section-para font-weight-normal m-0">
                            Since then, the Vantage Fit Global Corporate Virtual
                            Walkathon has become popular across organizations
                            and is being held annually.
                        </p>
                    </div>
                </div>
            </section>

            <section className="position-relative bg-white">
                <div className="container custom_container p0 m-d-block py-5">
                    <div className="row d-flex justify-content-start align-items-center">
                        <div className="col-12 col-lg-6 order-2 order-lg-1">
                            <p className="section-para font-weight-normal m-0">
                                The second (2022) and third (2023) seasons saw
                                increasing engagement and introduced a new
                                initiative, holistic wellness. Multi-activity
                                challenges were introduced as part of the
                                virtual walkathon, allowing users to engage by
                                exploring the Vantage Fit app's possibilities.
                                Activities included heart rate monitoring,
                                nutrition intake log, mindfulness sessions, etc.
                            </p>
                        </div>
                        <div className="col-12 col-lg-6 d-flex justify-content-center order-1 order-lg-2  py-5 py-lg-0">
                            <img
                                style={{ maxWidth: "400px" }}
                                src="https://res.cloudinary.com/vantagecircle/image/upload/v1728466895/VantageFit/2024/gcw/graph.png"
                                alt="graph"
                            />
                        </div>
                    </div>
                </div>
            </section>

            <section className="position-relative bg-white ">
                <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block py-5">
                    <div className="col-12 col-lg-6 d-flex justify-content-center order-2 order-lg-1  py-5 py-lg-0">
                        <img
                            style={{ maxWidth: "400px" }}
                            src="https://res.cloudinary.com/vantagecircle/image/upload/v1728466895/VantageFit/2024/gcw/Plant_tree.png"
                            alt="Plant_tree"
                        />
                    </div>
                    <div className="col-12 col-lg-6 order-1 order-lg-2">
                        <p className="section-para font-weight-normal m-0">
                            The second (2022) and third (2023) seasons saw
                            increasing engagement and introduced a new
                            initiative, holistic wellness. Multi-activity
                            challenges were introduced as part of the virtual
                            walkathon, allowing users to engage by exploring the
                            Vantage Fit app's possibilities. Activities included
                            heart rate monitoring, nutrition intake log,
                            mindfulness sessions, etc.
                        </p>
                    </div>
                </div>
            </section>

            <section className="position-relative bg-white pt-5 mt-5">
                <div className="col-12">
                    <h4 className="font-weight-normal m-0 text-center">
                        The Global Corporate Virtual Walkathon returns this year
                        with exciting <br />
                        surprises and improved functionality.
                    </h4>
                </div>
                <div className="col-12 d-flex justify-content-center pb-5 mb-5">
                    <img
                        className="w-50"
                        src="https://res.cloudinary.com/vantagecircle/image/upload/v1728279865/VantageFit/2024/gcw/walkathon_logo_2024-02.png"
                        alt="logo"
                    />
                </div>
            </section>

            <section
                id="gcwHubspotForm"
                name="gcwHubspotForm"
                className="gcw-formbg position-relative"
            >
                <div className="">
                    <div className="col-12 col-md-6 gcw-form-cont">
                        <div className="container">
                            <div className="padding-dem">
                                <h2 className="section-heading text-white mb-3">
                                    Register Your Team Now
                                </h2>
                                <HubspotBrochureDownload formID="7791aa6e-67f3-4e7c-b15e-cdc03d4288ce" />
                                {/* <div className="gcw-note">
                                    *One walkathon team can have between
                                    20-100 participants
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="gcwfeat section-pdn gcwmilestone">
                <h2 className="section-heading text-center text-light">
                    Helping Organizations Inspire Wellness
                </h2>
                <p className="section-para font-weight-normal text-center text-white mt-3 px-3 px-lg-5">
                    Is your team struggling to stay active and connected in
                    today's hybrid work environment? With Vantage Fit, watch
                    your team feel energized, connected, and motivated. Our
                    Global Virtual Walkathon has already helped hundreds of
                    teams break out of their sedentary routines.
                </p>
                <div className="container">
                    <div className="col-12 col-md-10 offset-md-1 px-0">
                        <div className="row">
                            <div className="col-6 col-sm-6 col-md-3 mb-3">
                                <div className="miles-sect">
                                    <div>
                                        <div className="mi-no">8100+</div>
                                        <div className="mi-txt">
                                            No. of Participants
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6 col-sm-6 col-md-3 mb-3">
                                <div className="miles-sect">
                                    <div>
                                        <div className="mi-no">30+</div>
                                        <div className="mi-txt">
                                            No. of Countries
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6 col-sm-6 col-md-3 mb-3">
                                <div className="miles-sect">
                                    <div>
                                        <div className="mi-no">$15k</div>
                                        <div className="mi-txt">
                                            Total Rewards Given
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6 col-sm-6 col-md-3 mb-3">
                                <div className="miles-sect">
                                    <div>
                                        <div className="mi-no">350M+</div>
                                        <div className="mi-txt">
                                            Total Steps Taken
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6 col-sm-6 col-md-3 mb-3">
                                <div className="miles-sect">
                                    <div>
                                        <div className="mi-no">250K+</div>
                                        <div className="mi-txt">
                                            Total Kms Covered
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6 col-sm-6 col-md-3 mb-3">
                                <div className="miles-sect">
                                    <div>
                                        <div className="mi-no">250+</div>
                                        <div className="mi-txt">
                                            Total Trees Planted
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6 col-sm-6 col-md-3 mb-3">
                                <div className="miles-sect">
                                    <div>
                                        <div className="mi-no">100+</div>
                                        <div className="mi-txt">
                                            No. of Companies
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-6 col-sm-6 col-md-3 mb-3">
                                <div className="miles-sect">
                                    <div>
                                        <div className="mi-no">12M+</div>
                                        <div className="mi-txt">
                                            Total Calories Burned
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="position-relative">
                <div className="col-12 mx-auto my-5 gcwCarousel pb-5 pt-5">
                    <h2 className="sectionTitle-center font-weight-bold text-center mb-5">
                        In the News
                    </h2>
                    <div className="col-lg-12 relative mb-5">
                        <GCWcarousel />
                    </div>
                </div>
            </section>

            <section className="bottom-feat-cta position-relative section-pdn-1 pt-8 feat_testi brad0">
                <div className="container custom_container d-flex justify-content-start align-items-center p0 m-d-block">
                    <div className="col-12">
                        <h2 className="section-heading text-center no-br">
                            <Trans>
                                Unlock the power of a happier <br />& healthier
                                workforce
                            </Trans>
                        </h2>
                        <div className="pl-0 col-12 mtb25 d-flex justify-content-center align-items-center">
                            <a
                                href={t(`/request-demo/`)}
                                className="vfitcompanycta arrowbtn-img"
                            >
                                <Trans>Book a Demo</Trans>
                            </a>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default GCWAboutUs;
